<template>
    <div id="resource-destination-control">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mb-4 mt-4 w-full">
                    <vs-table stripe :data="loanGuarantees" noDataText="No se han generado registros">
                        <template slot="header">
                            <h3>Garantías</h3>
                            <vs-button v-if="canEdit" @click.stop="popupActivo = true" class="mb-2 mr-2" size="small" color="success">Agregar garantía</vs-button>
                        </template>
                            <template slot="thead">
                            <vs-th class="bold">TIPO</vs-th>
                            <vs-th class="bold">GARANTÍA</vs-th>
                            <vs-th class="bold">ESTRATEGIA DE RECUPERACIÓN</vs-th>
                            <vs-th v-if="canEdit" class="bold">ACCIONES</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].loan_guarantees_type">
                                {{ uppercase(translateGuaranteeTypeEnum(data[indextr].loan_guarantees_type)) }}
                                </vs-td>

                                <vs-td :data="data[indextr].loan_guarantees_name">
                                {{ uppercase(data[indextr].loan_guarantees_name) }}
                                </vs-td>

                                <vs-td :data="indextr">
                                {{ uppercase(data[indextr].recovery_strategy||"sin definición") }}
                                </vs-td>

                                <vs-td v-if="canEdit" :data="data[indextr].id">
                                    <vs-button @click="deleteDestinationRequest(tr)" radius size="small" type="border" icon="delete" color="danger"></vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>

        <vs-popup title="Agregar garantía" :active.sync="popupActivo">
            <div class="vx-row">
                <div class="vx-col">
                    <vx-card title="Nueva garantía">
                        <p class="mb-2">Define las garantías del crédito, recuerda que esta información será visible para toda la comunidad.</p>
                        <vs-divider></vs-divider>
                        <vs-select
                            class="w-full"
                            v-model.lazy="loanGuaranteeSelected"
                            name="loanGuaranteeSelected"
                            placeholder="Seleccione una opción">
                            
                            <vs-select-item
                            :key="index"
                            :value="item.id"
                            :text="item.select_name"
                            v-for="(item,index) in collections.loan_guarantees"
                            class="w-full"
                            />
                        </vs-select>
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button type="line" class="mt-4" @click="popupActivo = false">Cerrar</vs-button>
                            <vs-button class="ml-2 mt-4" @click="saveDestinationRequest()">Guardar cambios</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';
export default {
    name: "loan-guarantees-control",
    props: ["projectId", "canEdit"],
    mixins: [
        inputHelper
    ],
    data() {
        return {
            loanGuarantees: [],
            collections: {
                loan_guarantees: []
            },
            popupActivo: false,
            loanGuaranteeSelected: null,
            currentProjectFinanceId: null,
            itemToDelete: null
        }
    },
    mounted() {
        this.getCurrentLoanGuarantees();
        this.getCollections();
    },
    methods: {
        async getCollections(){
            try {
                let collectionsObjects = ['getLoanGuarantee'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.loan_guarantees = colls.getLoanGuarantee;
            }
            catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getCurrentLoanGuarantees()
        {
            try {
                const res = await axios.get(`/api/get/loan-guarantees/by-project/${this.projectId}`)
                this.loanGuarantees = res.data;
            } catch (error) {
                console.error(error);
            }
        },

        saveDestinationRequest(item) {
            this.currentProjectFinanceId = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Nueva garantía",
                text: "Se agregará una nueva garantía para el crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestSave
            });
        },
        async doRequestSave() {
            try {
                this.showLoading(true);
                const payload = {
                    project_id: this.projectId
                    , new_relation: this.loanGuaranteeSelected
                }
                await axios.post(`/api/post/loan-guarantees/new`, payload);
                this.getCurrentLoanGuarantees();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },

        deleteDestinationRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: "Borrar destino",
                text: "Se eliminará una garantía para el crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestDelete
            });
        },
        async doRequestDelete() {
            try {
                this.showLoading(true);
                const payload = {
                    project_finance_id: this.itemToDelete.project_finances_id
                    , loan_gurantee_id: this.itemToDelete.loan_guarantees_id
                }
                await axios.post(`/api/delete/loan-guarantees`, payload);
                this.getCurrentLoanGuarantees();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        translateGuaranteeTypeEnum(type) {
            const types = {
                "real_real_state" :	"Bien inmueble",
                "real_property" :	"Bien mueble",
                "real_accounts_receivable" :	"Cuentas por cobrar",
                "personal_jointly_bound" :	"Obligado Solidario",
                "promissory_note" :	"Pagaré",
                "default" :	"No definido",
            };

            return (types[type] || types["default"]);
        }
    }

}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }
</style>